<template>
    <table class="table table-condensed">
        <thead>
            <tr>
                <th class="text-center">{{ $t('aa:number')}}</th>
                <th class="text-center">{{ $t('aa:executive_body')}}</th>
                <th class="text-center">{{ $t('aa:procedure')}}</th>
                <th class="text-center">{{ $t('aa:building:description')}}</th>
                <th class="text-center">{{ $t('aa:date:issued')}}</th>
                <th class="text-center">{{ $t('aa:date:legally')}}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(permit, inx) in acts" :key="`aa_${inx}`">
                <td class="text-center">
                    {{ permit.POSTOPEK_EGR_STEVILKA_ZADEVE }}
                </td>
                <td class="text-center">
                    {{ permit.ORGAN_VLOZITVE_EGR_POLNI_NAZIV }}
                </td>
                <td class="text-center">
                    {{ permit.POSTOPEK_EGR_ID }}
                </td>
                <td class="text-center">
                    {{ permit.VRSTA_UA_NAZIV }}
                </td>
                <td class="text-center">
                    {{ permit.DATUM_POPOLNOSTI }}
                </td>
                <td class="text-center">
                    {{ permit.DATUM_PRAVNOMOCNOSTI }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "AdministrativeActsPopupTable",
    props: ['acts'],
    methods: {
        nonBreakableReKey(re_key) {
            // replace - with non breakable hyphen and / with non breakable slash
            return re_key.replace(/-/g, '-\u00AD').replace(/\//g, '/\u00AD');
        },
    },

}
</script>

<style scoped>
.table>tbody>tr>td,
.table>tbody>tr>th,
.table>thead>tr>td,
.table>thead>tr>th {
    padding: 7px 4px;
}
</style>
